import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Alert, AlertDescription } from '../ui/alert';
import { Loader2, X } from 'lucide-react';
import Affiliate_refferal_url_list from './Affiliate_refferal_url_list';
import Price_request_pop from './Price_request_pop';
import { userService } from "../../_services";

function AffiliateReferralUrl({ 
    isDocuSigned, 
    referralLink_AdminApproval, 
    referralLink_RequestStatus, 
    powerform_link,
    update_affiliate_request 
}) {
    const [showAddAffiliate, setShowAddAffiliate] = useState(false);
    const [requestBox, setRequestBox] = useState(false);
    const [requestType, setRequestType] = useState('');
    const [showCalendly, setShowCalendly] = useState(false);
    const [endPointText, setEndPointText] = useState('');
    const [userId, setUserId] = useState('');
    const [refId, setRefId] = useState('-1');
    const [emptyArray, setEmptyArray] = useState(true);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const User_Data = window.atob(localStorage.getItem('ajs_user_id'));
        setUserId(User_Data.split(':')[0]);
    }, []);

    const submitRequest = (event) => {
        if (update_affiliate_request) {
            update_affiliate_request();
        }
        setRequestBox(false);
        setShowCalendly(true);
    };

    const saveReferralURL = async (e) => {
        e.stopPropagation();
        setRefId('-1');
        setEndPointText('');
        setUpdateLoader(true);
        
        try {
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const apidata = await userService.Save_Update_ReferralURL(refId, endPointText, userId);
            
            if (apidata.length > 0) {
                setShowAddAffiliate(!showAddAffiliate);
                setEmptyArray(false);
                
                if (apidata[0].code === "-1") {
                    setError("Error! Please try later");
                }
            }
        } catch (error) {
            console.error('Error saving referral URL:', error);
        } finally {
            setUpdateLoader(false);
        }
    };

    const toggleRequestPop = (requesttype, e) => {
        if (e !== undefined) {
            e.stopPropagation();
            setRequestType(requesttype);
        } else if (requesttype && requesttype.stopPropagation) {
            requesttype.stopPropagation();
        }
        setRequestBox(!requestBox);
    };

    const handleCalendlyOpen = (e) => {
        setShowCalendly(true);
    };

    const handleCalendlyClose = () => {
        setShowCalendly(false);
    };

    return (
        <div>
            <Card className={isDocuSigned === false ? "pricing_tool_box" : "affiliate_refferal"}>
                {isDocuSigned === false ? (
                    <CardContent className="pt-6">
                        <div className="requesting_box">
                            <p className="text-lg font-semibold mb-4">Affiliate Referral URL</p>
                            <div className="btn_box space-y-3">
                                {referralLink_AdminApproval === false && referralLink_RequestStatus === "" && (
                                    <Button
                                        variant="secondary"
                                        onClick={(e) => toggleRequestPop("ref", e)}
                                        className="w-full"
                                    >
                                        Click to Request Affiliate URL
                                    </Button>
                                )}
                                
                                {referralLink_AdminApproval === false && referralLink_RequestStatus === "Requested" && (
                                    <div className="text-center text-gray-600 py-2">
                                        Your request is pending
                                    </div>
                                )}
                                
                                {referralLink_AdminApproval === true && referralLink_RequestStatus === "Requested" && (
                                    <div className="text-center text-gray-600 py-2">
                                        Your request is pending
                                    </div>
                                )}
                                
                                {referralLink_AdminApproval === true && referralLink_RequestStatus === "Approved" && (
                                    <Button
                                        variant="secondary"
                                        asChild
                                        className="w-full"
                                    >
                                        <a href={powerform_link}>
                                            Click to sign document
                                        </a>
                                    </Button>
                                )}
                                
                                {referralLink_AdminApproval === true && referralLink_RequestStatus === "Rejected" && (
                                    <Button
                                        variant="secondary"
                                        onClick={(e) => toggleRequestPop('ref', e)}
                                        className="w-full"
                                    >
                                        Rejected, Request to Admin
                                    </Button>
                                )}
                            </div>
                        </div>
                    </CardContent>
                ) : (
                    <>
                        <CardHeader>
                            <div className="flex items-center justify-between">
                                <CardTitle>Affiliate Referral URL</CardTitle>
                                <Button
                                    variant="secondary"
                                    onClick={saveReferralURL}
                                    disabled={updateLoader}
                                >
                                    {updateLoader ? (
                                        <><Loader2 className="h-4 w-4 animate-spin mr-2" />Adding...</>
                                    ) : (
                                        'Click to Add URL'
                                    )}
                                </Button>
                            </div>
                        </CardHeader>
                        <CardContent>
                            {error && (
                                <Alert variant="destructive" className="mb-4">
                                    <AlertDescription>{error}</AlertDescription>
                                </Alert>
                            )}
                            <div className="table_area">
                                <div className="table_head grid grid-cols-3 gap-4 font-semibold pb-2 border-b">
                                    <div>Referral URL</div>
                                    <div>Number of Signups</div>
                                    <div>Action</div>
                                </div>
                                <Affiliate_refferal_url_list noURl={emptyArray} />
                            </div>
                        </CardContent>
                    </>
                )}
            </Card>

            {/* Calendly Dialog */}
            <Dialog open={showCalendly} onOpenChange={setShowCalendly}>
                <DialogContent className="max-w-4xl h-[600px]">
                    <DialogHeader>
                        <DialogTitle>Schedule a Call</DialogTitle>
                    </DialogHeader>
                    <div className="flex-1 h-full">
                        <iframe 
                            src="https://calendly.com/rxhackerpro/15min" 
                            width="100%" 
                            height="100%" 
                            frameBorder="0"
                            className="rounded"
                        />
                    </div>
                    <DialogFooter>
                        <Button onClick={handleCalendlyClose}>Close</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            {/* Request Popup */}
            {requestBox && (
                <Price_request_pop 
                    CloseRequestPopUp={toggleRequestPop} 
                    request_type={requestType} 
                    submit_Request_affiliate={submitRequest} 
                />
            )}
        </div>
    );
}

export default AffiliateReferralUrl;
